import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <main className="notfound-page">
      <section className="notfound-frame">
        <div className="notfound-sheep">
          <img
            src="/assets/blind-sheep.webp"
            alt="A small blind sheep with a gold bell, lost in the fog."
          />
        </div>

        <div className="notfound-text">
          <span className="notfound-eyebrow">404</span>
          <h1 className="notfound-title">Oops.</h1>
          <p className="notfound-lead">
            It looks like you have stumbled into the fog of confusion.
          </p>
          <p className="notfound-help">
            Need a little help?
          </p>
          <Link to="/" className="notfound-btn-gold">
            Click here to return home
          </Link>
        </div>
      </section>
    </main>
  );
}

export default NotFoundPage;
